import { UserRole } from '@domain/schemas/user-role';
import { DocumentMode } from '@helpers/document-mode';

import { mrc } from './source/naming-mrc';

const language = {
  user: {
    role: {
      [UserRole.Admin]: 'Admin',
      [UserRole.Superadmin]: 'Super Admin',
      [UserRole.User]: 'User',
      [UserRole.TemplateManager]: 'Template Manager',
      [UserRole.Broker]: 'Broker',
    },
  },
  menu: {
    pages: {
      submissions: 'Submissions',
      templates: 'Templates',
      blockLibrary: 'Block Library',
      tags: 'Tags',
      users: 'Users',
    },
    userBadge: {
      logout: 'Logout',
    },
  },
  buttons: {
    save: 'Save',
    cancel: 'Cancel',
    saveChanges: 'Save changes',
    create: 'Create',
  },
  naming: {
    mrc,
  },
  [DocumentMode.SUBMISSIONS]: {
    title: 'Contract',
    notifications: {
      statusUpdate: {
        archived: 'This contract is not being used.',
        final: 'This contract is complete.',
        draft: 'This contract is a work in progress.',
        'firm order': 'This contract is going to firm order and will soon be bound.',
        review: 'This contract can be reviewed.',
      },
    },
  },
  [DocumentMode.BRANDING]: {
    title: 'Branding',
    notifications: {
      statusUpdate: {
        archived: 'This branding is not available to use.',
        published: 'This branding is available to use.',
        draft: 'This branding is a work in progress.',
      },
    },
  },
  [DocumentMode.TEMPLATES]: {
    title: 'Templates',
    notifications: {
      statusUpdate: {
        archived: 'This template is not available to use.',
        published: 'This template is available to use.',
        draft: 'This template is a work in progress.',
        review: 'This template is awaiting Super Admin sign-off.',
      },
    },
  },
  [DocumentMode.ENDORSEMENTS]: {
    title: 'Endorsements',
    notifications: {
      statusUpdate: {
        archived: 'This endorsement is not being used.',
        final: 'This endorsement is complete.',
        draft: 'This endorsement is a work in progress.',
        review: 'This endorsement is read-only and ready for review.',
      },
    },
  },
};

export default language;
